import { TaxaAPI } from "@/api/taxa.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { TaxaAvulsa } from "@/models/taxa_avulsa";

const taxaApi = new TaxaAPI();

const getAll = (): AxiosObservable<TaxaAvulsa[]> => {
  return taxaApi.getAll();
};

const emitirTaxa = (taxa: any): AxiosObservable<any> => {
  return taxaApi.emitirTaxa(taxa);
};

export default { getAll, emitirTaxa };
